var inlet = require('aem-libs/src/initInlet.js').initInlet(
  'AemCspsDpsChildren',
  /* global WEBPACK_INLET_VERSION */ WEBPACK_INLET_VERSION
)
var angular = require('angular')
require('angular-sanitize')
require('aem-libs-angularjs/src/components/responsive-date-picker/responsive-date-picker.component.js')
require('aem-libs-angularjs/src/components/number-input-plus-minus-step/number-input-plus-minus-step.component.js')
require('aem-libs-angularjs/src/filters/currency-amount-formatter.filter.js')
require('aem-libs-angularjs/src/components/backend-error/backend-error.component.js')
var pensionSavingsPlanService = require('aem-libs-angularjs/src/services/pension-savings-plan.service').pensionSavingsPlanService
var widgetParamsService = require('aem-libs-angularjs/src/services/widgetParams.service.js').widgetParamsService
var pensionCpsService = require('aem-libs-angularjs/src/services/pension-cps.service').pensionCpsService

angular.module('AemCspsDpsChildren', ['NumberInputPlusMinusStepCmp', 'ResponsiveDatePickerCmp', 'currencyAmountFormatterCmp', 'BackEndErrorComp', 'ngSanitize'])
  .factory('pensionSavingsPlanService', pensionSavingsPlanService)
  .factory('widgetParamsService', widgetParamsService)
  .factory('pensionCpsService', pensionCpsService)

require('./inlet.css')
require('./inlet.controller.js')

require('aem-libs-angularjs/src/bootstrap').bootstrap({
  element: inlet.element,
  appName: 'AemCspsDpsChildren',
  mainCtrlName: 'AemCspsDpsChildrenCtrl',
  basePath: inlet.basePath,
  config: /* global WEBPACK_INLET_CONFIG */ WEBPACK_INLET_CONFIG,
  supportedLanguages: {
    cs: require('./i18n/cs.js').cs,
    en: require('./i18n/en.js').en
  },
  html: require('./inlet.html')
})
